export const FOLDER_START_ID = 'FOLDER_';

export const FILE_TYPE = {
  FILE: 'file',
  FOLDER: 'folder',
} as const;

export const FILES_ACTION = {
  VIEW: 'view',
  DOWNLOAD: 'download',
  PREVIEW: 'preview',
};

export const FOLDER_FILE_KEY = '__placeholder__';

export const FILE_ACCESS_LEVEL = {
  READ_ONLY: 'read_only',
  READ_WRITE: 'read_write',
} as const;

export const ESIGNATURE_PAGE_MARGIN = 15;

// currently only the presence of / is being checked, so the
// error message is specific
// in future, this can be made dynamic depending on the checks we want to perform
export const FOLDER_VALIDATION_ERR_MSG = 'Folder name cannot contain a /';

// Must stay in sync with backend/lib/constants/s3.go InvalidS3PathChars
export const INVALID_S3_PATH_CHARS = ['*', '=', '|', '@', '^'] as const;

export const INVALID_S3_PATH_CHARS_ERR_MSG = `Cannot contain special characters (${INVALID_S3_PATH_CHARS.join(
  ',',
)}) in name`;

export const INVALID_S3_PATH_CHARS_UPLOAD_ERR_MSG = `Folder or file names cannot contain special characters (${INVALID_S3_PATH_CHARS.join(
  ',',
)})`;

export const IMAGE_FORMATS = ['png', 'jpg', 'jpeg', 'gif'];
